import { queryDocuments } from "@smart/manage-gql-operations-dom";

import { useQueryFactory } from "./base";

export const useLoadInfoTrackSetupState = useQueryFactory(
  queryDocuments.infoTrackSetupState,
  { map: ({ infoTrackSetupState }) => infoTrackSetupState },
);
